import * as Yup from 'yup';

interface CreateAddressSchemaOptions {
  excludeNY?: boolean;
}

/**
 * Factory function that creates a Yup address schema with configurable validation rules.
 * @param options - Configuration options for the schema
 * @param options.excludeNY - If true, excludes New York state from valid addresses
 * @returns A Yup object schema for address validation
 */
export const createAddressSchema = (options?: CreateAddressSchemaOptions) => {
  const { excludeNY = false } = options || {};

  let stateSchema = Yup.string().trim().required('This field is required');

  if (excludeNY) {
    stateSchema = stateSchema.test('not-ny', 'New York is not currently supported', value => value !== 'NY');
  }

  return Yup.object({
    street: Yup.string().trim().required('This field is required'),
    city: Yup.string().trim().required('This field is required'),
    state: stateSchema,
    zip: Yup.string()
      .trim()
      .required('This field is required')
      .matches(/^[0-9]+$/, 'Invalid Zip Code')
      .length(5, 'Invalid Zip Code'),
  });
};

// Convenience exports for common configurations
export const addressSchema = createAddressSchema({ excludeNY: false });
export const addressExcludeNYSchema = createAddressSchema({ excludeNY: true });
